/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_No_Audio_WarningInputs */

const en_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output will have no audio tracks (video and metadata only).`)
};

const fr_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le résultat ne comportera aucune piste audio (uniquement de la vidéo et des métadonnées).`)
};

const de_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ausgabe enthält keine Audiospur (nur Video und Metadaten).`)
};

const it_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'output non conterrà tracce audio (solo video e metadati).`)
};

const ru_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В выходном файле не будет звуковых дорожек (только видео и метаданные).`)
};

const es_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La salida no tendrá pistas de audio (solo vídeo y metadatos).`)
};

const zh_cn2_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出将不包含音频轨道（仅包含视频和元数据）。`)
};

const ja_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力には音声トラックは含まれません（ビデオとメタデータのみ）。`)
};

const hi_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट में कोई ऑडियो ट्रैक नहीं होगा (केवल वीडियो और मेटाडेटा)।`)
};

const pt_pt2_audio_embed_export_no_audio_warning = /** @type {(inputs: Audio_Embed_Export_No_Audio_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O resultado não terá faixas de áudio (apenas vídeo e metadados).`)
};

/**
* | output |
* | --- |
* | "Output will have no audio tracks (video and metadata only)." |
*
* @param {Audio_Embed_Export_No_Audio_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_no_audio_warning = /** @type {((inputs?: Audio_Embed_Export_No_Audio_WarningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_No_Audio_WarningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_no_audio_warning(inputs)
	if (locale === "de") return de_audio_embed_export_no_audio_warning(inputs)
	if (locale === "it") return it_audio_embed_export_no_audio_warning(inputs)
	if (locale === "ru") return ru_audio_embed_export_no_audio_warning(inputs)
	if (locale === "es") return es_audio_embed_export_no_audio_warning(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_no_audio_warning(inputs)
	if (locale === "ja") return ja_audio_embed_export_no_audio_warning(inputs)
	if (locale === "hi") return hi_audio_embed_export_no_audio_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_no_audio_warning(inputs)
	return en_audio_embed_export_no_audio_warning(inputs)
});